import { render, staticRenderFns } from "./DataStaff.vue?vue&type=template&id=79d883a4"
import script from "./DataStaff.vue?vue&type=script&lang=js"
export * from "./DataStaff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports